import React from "react";

const LoadingScreen = () => {
  return (
    <div className="loading_screen">
      <span className="loader"></span>
    </div>
  );
};

export default LoadingScreen;
